import React from 'react';
import { Link, useNavigate, useLocation } from 'react-router-dom';
import EmeraldHomesLogo from '../assets/emreld logo 2 long.png'; // Import the logo

const Navbar = ({ onContactClick }) => {
  const navigate = useNavigate();
  const location = useLocation(); // Get current location
  const token = localStorage.getItem('adminToken');

  const handleLogout = () => {
    localStorage.removeItem('adminToken');
    navigate('/login');
  };

  // Check if current route is an admin route
  const isAdminRoute = location.pathname.startsWith('/admin');

  return (
    <header className="fixed top-0 w-full z-50 bg-white/85 backdrop-blur-lg border-b border-zinc-200/50 transition-all duration-300">
      <div className="w-full flex justify-between items-center h-20 md:h-28 px-4 md:px-6">
        
        {/* Logo Section */}
        <div className="flex items-center gap-4">
          <Link to="/" className="flex items-center group shrink-0">
            <img 
              src={EmeraldHomesLogo} 
              alt="Emerald Homes Logo" 
              className="h-12 md:h-24 w-auto max-w-[160px] sm:max-w-[350px] object-contain transform group-hover:scale-105 transition-transform duration-300" 
            />
          </Link>
          {/* Subtle Vertical Divider & Tagline (Desktop Only) */}
          <div className="hidden lg:block h-8 w-px bg-zinc-300 mx-2"></div>
          <p className="hidden lg:block text-[11px] font-bold text-zinc-400 tracking-widest uppercase mt-1">
            Your Trusted Partner
          </p>
        </div>

        {/* Mobile Contact */}
        <button 
          onClick={onContactClick}
          className="md:hidden px-4 py-2 rounded-full text-xs font-bold text-white uppercase tracking-wider bg-gradient-to-r from-emerald-600 to-emerald-400 shadow-lg shadow-emerald-500/30"
        >
          Contact
        </button>

        {/* Desktop Navigation */}
        <nav className="hidden md:flex items-center gap-8">
          <Link to="/" className="text-sm font-bold text-zinc-600 hover:text-emerald-600 uppercase tracking-wider transition-colors duration-200">
            Home
          </Link>
          
          {token && isAdminRoute && (
            <Link to="/admin/dashboard" className="text-sm font-bold text-zinc-600 hover:text-emerald-600 uppercase tracking-wider transition-colors duration-200">
              Dashboard
            </Link>
          )}

          <div className="flex items-center gap-4 ml-2">
            <button 
              onClick={onContactClick} 
              className="px-7 py-2.5 rounded-full text-sm font-bold text-white uppercase tracking-wider bg-gradient-to-r from-emerald-600 to-emerald-400 hover:from-emerald-500 hover:to-emerald-300 shadow-lg shadow-emerald-500/30 transform hover:-translate-y-0.5 transition-all duration-300"
            >
              Contact Us
            </button>

            {token && isAdminRoute && (
              <button 
                onClick={handleLogout} 
                className="px-6 py-2.5 rounded-full text-sm font-bold text-zinc-600 bg-zinc-100 hover:bg-red-50 hover:text-red-600 border border-zinc-200 hover:border-red-200 transition-all duration-300"
              >
                Logout
              </button>
            )}
          </div>
        </nav>
      </div>
    </header>
  );
};

export default Navbar;
